__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "OffersUI";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("launchdarkly-react-client-sdk", "3.7.0", () => (Promise.all([__webpack_require__.e(119), __webpack_require__.e(364), __webpack_require__.e(679)]).then(() => (() => (__webpack_require__(96119))))));
			register("react-dom", "16.13.1", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(364)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(364), __webpack_require__.e(337), __webpack_require__.e(901)]).then(() => (() => (__webpack_require__(89901))))));
			register("react-router", "5.2.0", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(364), __webpack_require__.e(201)]).then(() => (() => (__webpack_require__(1201))))));
			register("react", "16.13.1", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(40784);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};